import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const supplierRegistrationDetails = this.props.supplierRegistrationDetails;
        const supplierRegistrationDetailsInputs = this.props.supplierRegistrationDetailsInputs;
        return (
            <div>
                <h3><center><u>Supplier Registration Detail Report</u></center></h3>
                <h6><center>From Date - {supplierRegistrationDetailsInputs.fromDate} </center></h6>
                <h6><center>To Date - {supplierRegistrationDetailsInputs.toDate} </center></h6>
                <div>&nbsp;</div>
                <div>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Reg No
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Reg Name
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        RCode
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Route Name
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Dy No
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Address
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {supplierRegistrationDetails.map((row) => (
                                    <TableRow key={row.divisionID}>
                                        <TableCell component="th" align="center" >
                                            {row.customerCode == null ? '-' : row.customerCode}
                                        </TableCell>
                                        <TableCell colSpan={2} align="center" >
                                            {row.firstName == null ? '-' : row.firstName}
                                        </TableCell>
                                        <TableCell colSpan={2} align="center" >
                                            {row.collectionPointCode == null ? '-' : row.collectionPointCode}
                                        </TableCell>
                                        <TableCell colSpan={2} align="center" >
                                            {row.collectionPointName == null ? '-' : row.collectionPointName}
                                        </TableCell>
                                        <TableCell colSpan={2} align="center" >
                                            {row.mobileNo == null ? '-' : row.mobileNo}
                                        </TableCell>
                                        <TableCell colSpan={2} align="center" >
                                            {row.address1 == null ? '-' : row.address1}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        );
    }
}


